

import state from './moduleProductListState.js'
import mutations from './moduleProductListMutations.js'
import actions from './moduleProductListActions.js'
import getters from './moduleProductListGetters.js'

export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

